export const VOLUNTEERING = "VOLUNTEERING";

export const CUSTOMER_SERVICES = "CUSTOMER_SERVICES";

export const CONTRACTS = "CONTRACTS";
